import { IRegion } from '../../../../node/types/region';
import { IApplicationState } from '../../types/redux';

export function selectRegions(state: IApplicationState): IRegion[] | null {
  return state.regions;
}
